import React, { useState } from "react";
import logo from "./images/logo.png";
const Header = () => {
  const [hiddenMenu, setHiddenMenu] = useState("hidden-menu");
  function mostrarMenu() {
    setHiddenMenu("visible-menu");
  }
  function hiddenM() {
    setHiddenMenu("hidden-menu");
  }
  function stop(e) {
    e.preventDefault()
  }
  return (
    <header>
      <nav className="nav-header">
        <button
          className="menu"
          style={{
            border: "none",
            fontFamily: "sans-serif",
            fontSize: "2.3rem",
            background: "transparent",
          }}
          onClick={mostrarMenu}
        >
          <i class="bx bx-menu"></i>
        </button>
        <img src={logo} className="logo" alt="logo" />
        <article className={`enlaces-header ${hiddenMenu}`}>
          <a href="/" onClick={stop}>mujer</a>
          <a href="/" onClick={stop}>hombre</a>
          <a href="/" onClick={stop}>niños</a>
          <a href="/" onClick={stop}>deportes</a>
          <a href="/" onClick={stop}>marcas</a>
          <a href="/" onClick={stop}>colecciones</a>
          <button className="menu-close" onClick={hiddenM}>
            <i class="bx bx-x"></i>
          </button>
        </article>
        <article className="header-search">
          <input type="search" placeholder="buscar" />
          <i class="bx bx-user"></i>
          <i class="bx bx-shopping-bag"></i>
          <i class="bx bx-heart"></i>
        </article>
      </nav>
    </header>
  );
};

export default Header;
